<div class="dialog-content" *ngIf="form">
    <form [formGroup]="form" novalidate (submit)="submit()" class="flx-col">

        <h3 i18n="@@gen_offer_1">Określ parametry oferty</h3>
        <p i18n="@@gen_offer_trailer_about">Generowana oferta dotyczy aktualnie wyświetlanej przyczepy oraz jej konfiguracji.</p>

        <div class="flx-col product_price-wrap" *ngIf="product">
            <div class="flx-row"><ng-container i18n="@@gen_price">Twoja cena</ng-container><app-price *ngIf="product" [id]="product_copy.id" [price]="product_copy.price" [tax]="product_copy.tax" [quantity]="1" [currency]="product_copy.currency"></app-price></div>
            <div class="flx-row"><ng-container i18n="@@gen_price_client">Cena klienta</ng-container><app-price *ngIf="product" [id]="product.id" [price]="product.price" [tax]="product.tax" [quantity]="1" [currency]="product.currency"></app-price> / <app-price *ngIf="product" [type]="'brutto'" [id]="product.id" [price]="product.price" [tax]="product.tax" [quantity]="1" [currency]="product.currency"></app-price></div>
        </div>

        <mat-form-field appearance="outline">
            <mat-label i18n="@@gen_offer_2">Data ważności oferty</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="expiration_date">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label i18n="@@gen_offer_5">Stawka VAT</mat-label>
            <input matInput formControlName="tax">
        </mat-form-field>
          
        <div class="flx-dynamic flx-btwn-cntr-md flx-gap-default noerror mp">

            <mat-form-field appearance="outline" class="flx-grw">
            <mat-label i18n="@@gen_offer_3">Procentowa modyfikacja ceny - netto</mat-label>
            <input matInput formControlName="modified_percent">
            <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
            </mat-form-field>

            <span class="or" i18n="@@or" *ngIf="showGrossControls">lub</span>

            <mat-form-field appearance="outline" class="flx-grw" *ngIf="showGrossControls">
            <mat-label i18n="@@gen_offer_3_gross">Procentowa modyfikacja ceny - brutto</mat-label>
            <input matInput formControlName="modified_percent_gross">
            <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
            </mat-form-field>

        </div>

        <div class="flx-dynamic flx-btwn-cntr-md flx-gap-default noerror mp">

            <mat-form-field appearance="outline" class="flx-grw">
            <mat-label i18n="@@gen_offer_5_own">Własna cena - netto</mat-label>
            <input matInput formControlName="modified_price">
            <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
            </mat-form-field>

            <span class="or" i18n="@@or" *ngIf="showGrossControls">lub</span>

            <mat-form-field appearance="outline" class="flx-grw" *ngIf="showGrossControls">
            <mat-label i18n="@@gen_offer_4_gross">Własna cena - brutto</mat-label>
            <input matInput formControlName="modified_price_gross">
            <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
            </mat-form-field>

        </div>
<!-- 
        <label class="switch mb">
            <input type="checkbox" formControlName="tax_type">
            <span class="switch-style"></span>
            <ng-container i18n="@@gen_offer_51">oblicz cenę netto z Twojej ceny (domyślnie zostanie obliczona cena brutto)</ng-container>
        </label> -->

        <mat-form-field appearance="outline" >
        <mat-label i18n="@@gen_offer_comment">Uwagi do oferty</mat-label>
        <textarea matInput formControlName="comment"></textarea>
        </mat-form-field>

        <ng-container *ngIf="product_related">
            <h3 i18n="@@gen_offer_7">Dodaj do oferty dodatkowe akcesoria</h3>
            <p i18n="@@gen_offer_acc_about">Aby dodać dedykowane akcesoria do generowanej oferty zaznacz check'iem wybrane akcesoria.</p>

            <div formArrayName="related">
                <div *ngFor="let related_control of formRelated.controls; let i = index" class="flx-col variant flx-strt-strt" [formGroupName]="i">
                    <div class="w-100 flx-row flx-strt-strt">
                        <app-image [natural]="true" [url]="cdn +'/products/'+ product_related[i].photos_directory + '/thumb_' + product_related[i].photo"></app-image>
                        <div>
                            <h5>{{ product_related[i].title }}<br><span>{{ product_related[i].series }}</span></h5>
                        </div>

                        <div class="flx-col product_price-wrap">
                            <div class="flx-row flx-btwn-strt"><ng-container i18n="@@gen_price">Twoja cena</ng-container><app-price [id]="product_related_copy[i].id" [price]="product_related_copy[i].price" [tax]="product_related_copy[i].tax" [quantity]="1" [currency]="product_related[i].currency"></app-price></div>
                            <div class="flx-row flx-btwn-strt"><ng-container i18n="@@gen_price_client">Cena klienta</ng-container><app-price  [id]="product_related[i].id" [price]="product_related[i].price" [tax]="product_related[i].tax" [quantity]="1" [currency]="product_related[i].currency"></app-price></div>
                      </div>
                    </div>
                    <div class="w-100 flx-dynamic flx-btwn-cntr-md flx-gap-default noerror topborder">

                        <div class="switch-list">
                            <label class="switch">
                                <input type="checkbox" formControlName="selected">
                                <span class="switch-style"></span>
                                <ng-container i18n="@@addtooffer">Dodaj do oferty</ng-container>
                            </label>
                        </div>  

                        <mat-form-field appearance="outline" class="flx-grw">
                        <mat-label i18n="@@gen_offer_3_percent">Procentowa modyfikacja ceny</mat-label>
                        <input matInput formControlName="modified_percent">
                        <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
                        </mat-form-field>
            
                        <span class="or" i18n="@@or">lub</span>
            
                        <mat-form-field appearance="outline" class="flx-grw">
                        <mat-label i18n="@@gen_offer_4">Własna cena</mat-label>
                        <input matInput formControlName="modified_price">
                        <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
                        </mat-form-field>
            
                    </div>
                </div>
            </div>

            <mat-form-field appearance="outline" style="margin-top:16px">
                <mat-label i18n="@@gen_offer_comment_akc">Uwagi do akcesoriów</mat-label>
                <textarea matInput formControlName="comment_sec"></textarea>
            </mat-form-field>
        </ng-container>

        <div class="actions flx-row flx-btwn-cntr flx-gap-half">
            <button type="button" class="stroked-button" (click)="close()" i18n="@@cancel">Anuluj</button>
            <button class="flat-button primary fat">
                <span i18n="@@gen_offer_8">Generuj ofertę</span>
            </button>
        </div>
    </form>
</div>